import __  from "lodash";
import axios from "axios";
import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const awbNumIsValid = (serial) => {
  if (serial) {
    const serialString = serial.toString();
    if (serialString.length < 8)
      return false;
    const lastDigit = serialString[7];
    const checkValue = parseInt(serialString.substr(0,7));
    const checkDigit = checkValue % 7;
    if (parseInt(lastDigit) === checkDigit)
      return true;
  }
  return false;
}

const getRates = (baseCurrency, exchangeRates) => {
  const baseRate = __.find(exchangeRates, {currencyCode: baseCurrency}) || 0;
  const usdRate = __.find(exchangeRates, {currencyCode: "USD"}) || 0;
  const gbpRate = __.find(exchangeRates, {currencyCode: "GBP"}) || 0;

  const baseToEur = baseRate.rate;
  const baseToUsd = baseRate.rate * usdRate.inverseRate;
  const baseToGbp = baseRate.rate * gbpRate.inverseRate;

  return {baseToEur, baseToUsd, baseToGbp}
};

const getCurrencyName = (currencyCode, currencies) => {
  const currency = __.find(currencies, {currencyCode: currencyCode});
  return (currency ? currency.currencyName : "");
}

const getBookingFlightOptions = async (SystemData, flightDate, origin, destination, companyUuid) => {

  try {
    SystemData.toggleLoadingProgress(true, "Searching for available flight options");
    const response = await axios.get(`${apiSitePrefix}/booking/flightoptions/${flightDate}/${origin}/${destination}/${companyUuid}`);
    if (response.data) {
      SystemData.toggleLoadingProgress(false);
      return response.data;
    }

    if (!response.data) {
      SystemData.toggleLoadingProgress(false);
      return null;
    }
  } catch (err) {
    SystemData.toggleLoadingProgress(false);
    console.log(`Could not retrieve flight options. Server is not responding`);
    SystemData.alert("Error", `Could not retrieve flight options. Server is not responding`);
  }

  return null;
}

const getSearchValues = (params) => {
  const keys = [];
  if (__.has(params, "airlineCode") && __.has(params, "flightNo")) {
    keys.push(params.airlineCode !== "" && params.flightNo !== "" ? params.airlineCode : "null");
    keys.push(params.airlineCode !== "" && params.flightNo !== "" ? params.flightNo : "null");
  }
  keys.push(__.has(params, "tripNumber") && params.tripNumber !== "" ? params.tripNumber : "null");
  keys.push(__.has(params, "fromFlightDate") && params.fromFlightDate ? params.fromFlightDate : "null");
  keys.push(__.has(params, "toFlightDate") && params.toFlightDate  ? params.toFlightDate : "null");
  keys.push(__.has(params, "destinationAirportCode") && params.destinationAirportCode !== "" ? params.destinationAirportCode : "null");
  keys.push(__.has(params, "clientUuid") && params.clientUuid !== "" ? params.clientUuid : "null");
  keys.push(__.has(params, "accountManagerId") && params.accountManagerId !== "" ? params.accountManagerId : "null");
  if (__.has(params, "awbPrefix") && __.has(params, "awbSerial")) {
    keys.push(params.awbPrefix !== "" && params.awbSerial !== "" ? params.awbPrefix : "null");
    keys.push(params.awbPrefix !== "" && params.awbSerial !== "" ? params.awbSerial : "null");
  }
  keys.push(__.has(params, "allotment") && params.allotment !== "" ? params.allotment : "null");
  keys.push(__.has(params, "bookingStatus") && params.bookingStatus !== "" ? params.bookingStatus : "null");

  return (keys);
}

export {
  getRates,
  getCurrencyName,
  getBookingFlightOptions,
  getSearchValues,
  awbNumIsValid,
}

